import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicPriceLow({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.67 2.85h3.55c.71 0 1.28.57 1.28 1.27L6.67 2.85zm0 0l4.83 1.27v3.61a1.24 1.24 0 01-.37.84L6.7 13a1.26 1.26 0 01-1.72 0L1.34 9.38A1.22 1.22 0 011 8.52c0-.28.1-.61.34-.86l4.38-4.38c.24-.27.59-.43.95-.43zm3.5 1.33H6.7l-.03.02-4.32 4.32L5.83 12l4.34-4.35V4.18zm3.42 10.09l.03-.03.05-.04 1.74-1.68a.62.62 0 00-.8-.96l-.07.06-.68.66V8.12a.62.62 0 00-1.24-.08v4.24l-.68-.66a.62.62 0 00-.93.83l.06.07 1.74 1.68.05.05.04.02.04.03.04.02.07.03.1.02a.63.63 0 00.36-.06l.08-.04zM9.24 6.13a1.02 1.02 0 10-2.04 0 1.02 1.02 0 002.04 0z"
      />
    </svg>
  );
}

SvgBasicPriceLow.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicPriceLow.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicPriceLow svgRef={ref} {...props} />);
export default ForwardRef;
